import DownloadFileUseCase from "@domains/salesFeatures/Downloads/useCases/DownloadFileUseCase";
import DownloadPageListUseCase from "@domains/salesFeatures/Downloads/useCases/DownloadPageListUseCase";
export default (function (repo) {
    return {
        downloads: {
            downloadFile: new DownloadFileUseCase(repo.downloads),
            downloadPageFileList: new DownloadPageListUseCase(repo.downloads)
        },
    };
});
